import {
  Component, forwardRef,
  Input, OnChanges, OnInit, SimpleChanges,
  ViewChild,
} from '@angular/core';
import { LMFacadeService, LMFieldValueChangedEvent, LMLookupBasicComponent } from '@app/components';

@Component({
  selector: 'lm-facade-picker-dialog-picker',
  standalone: false,
  template: `
    @if (type) {
      <lm-lookup-basic
          [fieldLabel]="label"
          [sourceField]="sourceField"
          [selectListUrl]="selectListUrl"
          [viewType]="'list'"
          [viewName]="sourceField"
          (lookupValueChangedEvent)="handleLookupValueChanged($event)"
      >
      </lm-lookup-basic>
    }
  `,
})
export class LMFacadePickerDialogComponent implements OnInit {

  @Input() label: string | undefined;
  @Input() type: LMFacadeSelectType | undefined;

  @ViewChild(forwardRef(() => LMLookupBasicComponent)) lmLookupBasicBO: LMLookupBasicComponent | undefined;

  selectListUrl: string | undefined;
  sourceField: string | undefined;
  value = '';


  constructor(
    protected lmFacadeService: LMFacadeService
  ) {
    // no-op
  }

  ngOnInit(): void {
    if (this.type) {
      this.selectListUrl = this.lmFacadeService.getSelectUrl(this.type);
      this.sourceField = this.type === 'businessClass' ? 'BusinessView' : 'ReportCategory';
    }
  }

  handleLookupValueChanged(event: LMFieldValueChangedEvent) {
    if (this.lmLookupBasicBO)
      this.value = this.lmLookupBasicBO.lookupValue;
  }
}
